import './assets/style/main.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import './global.scss';

import { startTransition, Suspense, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router';

import AccordionLoader from './components/reusable/AccordionLoader';
import { pageurl } from './constants/pageurl';
import AdminRoute from './routes/admin-route';
import AuthRoute from './routes/auth-route';
import { ReactLazyPreload, routeComponent } from './routes/route-component';

const LoginPage = ReactLazyPreload(async () => await import('./app/login'));
const Page404 = ReactLazyPreload(async () => await import('./app/page404'));
const VerifyOTP = ReactLazyPreload(async () => await import('./app/verify-otp'));

const App = () => {
	useLayoutEffect(() => {
		startTransition(() => {
			routeComponent.forEach((i) => {
				i?.Component?.preload?.();
			});
		});
	}, []);

	return (
		<Router basename={process.env.PUBLIC_URL}>
			<Suspense
				fallback={
					<div
						style={{ width: '100%', height: '100vh' }}
						className='f-column text-center align-items-center justify-content-center'
					>
						<AccordionLoader
							size={96}
							label='Loading iElect'
						/>
					</div>
				}
			>
				<Routes>
					<Route
						path='/admin'
						element={<AdminRoute />}
					>
						{routeComponent.map(({ path, Component }, index) => (
							<Route
								path={path}
								element={<Component />}
								key={index + path}
							/>
						))}
					</Route>

					<Route
						path='/'
						element={<AuthRoute />}
					>
						<Route
							path={pageurl.LOGIN}
							element={<LoginPage />}
						/>

						<Route
							path={pageurl.VERIFYOTP}
							element={<VerifyOTP />}
						/>
					</Route>

					<Route
						path='*'
						element={<Page404 />}
					/>
				</Routes>
			</Suspense>
		</Router>
	);
};

export default App;
